(function () {
  const cfgEl = document.getElementById('loc-config-json');
  if (!cfgEl || !window.themeVariables?.localizationSelector) return;
  if (window.Shopify?.designMode) return;

  const cfg = JSON.parse(cfgEl.textContent);
  const keys = window.themeVariables.localizationSelector.keys;
  const marketChoiceKey = keys.marketChoice || 'market-choice';

  const els = {
    picker: document.getElementById('localization-picker-modal'),
    wrong: document.getElementById('localization-wrong-market-modal'),
  };
  if (!els.picker || !els.wrong) return;

  const inputs = {
    form: document.getElementById('localization-picker-form'),
    country: document.getElementById('loc-picker-country-input'),
    locale: document.getElementById('loc-picker-locale-input'),
  };

  const picker = {
    triggers: document.querySelectorAll('[data-loc-open]'),
    countryOpts: els.picker.querySelectorAll('[data-country-code]'),
    langOpts: els.picker.querySelectorAll('[data-locale-code]'),
    countryLabel: els.picker.querySelector('[data-loc-country-label]'),
    langLabel: els.picker.querySelector('[data-loc-lang-label]'),
    countryFlag: els.picker.querySelector('[data-loc-country-flag-wrap]'),
    countryListOpts: els.picker.querySelectorAll('#loc-picker-country-list .loc-picker__option'),
    langListOpts: els.picker.querySelectorAll('#loc-picker-language-list .loc-picker__option'),
    closeCtrls: els.picker.querySelectorAll('[data-loc-picker-overlay], [data-loc-picker-cancel]'),
    dropdowns: els.picker.querySelectorAll('[data-loc-dropdown]'),
    menuDrawer: document.getElementById('header-menu'),
  };

  const wrong = {
    closeTargets: els.wrong.querySelectorAll('[data-loc-modal-close]'),
    stay: document.getElementById('loc-wrong-market-stay'),
    openPickerBtns: els.wrong.querySelectorAll('[data-open-localization-picker-from-wrong]'),
    title: document.getElementById('loc-wrong-market-title'),
    subtitle: document.getElementById('loc-wrong-market-subtitle'),
  };

  const state = {
    country: cfg.currentCountry,
    locale: cfg.currentLocale,
  };

  let lastWrongMarketDetectedIso = null;
  let returnFocusTarget = null;
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function openModalElement() {
    if (!els.picker.hidden) return els.picker;
    if (!els.wrong.hidden) return els.wrong;
    return null;
  }

  function focusablesIn(modal) {
    return Array.from(modal.querySelectorAll(focusableSelector)).filter((element) => element.getClientRects().length > 0);
  }

  function moveFocusInto(modal, returnTo) {
    const active = document.activeElement;
    returnFocusTarget = returnTo || (active && !active.closest('.loc-modal') ? active : returnFocusTarget);
    const first = focusablesIn(modal)[0];
    if (first) first.focus({ preventScroll: true });
  }

  function restoreFocus(restore) {
    const target = returnFocusTarget;
    returnFocusTarget = null;
    if (!restore || !target || !target.isConnected || target === document.body) return;
    target.focus({ preventScroll: true });
  }

  function markAsSeen() {
    sessionStorage.setItem(keys.session, 'true');
  }

  function getMarketStatus(detectedIso, storefrontIso, apiData) {
    if (!detectedIso) return 'unknown';

    const isSellable = isDetectedInSellableMarkets(detectedIso, apiData);

    if (!isSellable) return 'not-sellable';
    if (detectedIso !== storefrontIso) return 'mismatch';

    return 'correct';
  }

  function setMarketChoice(iso) {
    if (!iso) return;

    const value = iso.toUpperCase();

    try {
      localStorage.setItem(marketChoiceKey, value);
    } catch (e) { }

    document.cookie = `${marketChoiceKey}=${value}; path=/; max-age=31536000; SameSite=Lax; Secure`;
  }

  function getMarketChoice() {
    try {
      const val = localStorage.getItem(marketChoiceKey);
      if (val) return val;
    } catch (e) { }

    const match = document.cookie.match(new RegExp('(^| )' + marketChoiceKey + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function clearMarketChoice() {
    try {
      localStorage.removeItem(marketChoiceKey);
    } catch (e) {
      /* ignore */
    }
  }

  function getLocalesForCountry(iso) {
    const map = cfg.languagesByCountry || {};
    const codes = map[iso];
    const finalCodes = Array.isArray(codes)
      ? codes.length
        ? codes
        : []
      : (cfg.availableLanguages || []).map((l) => l.iso_code);
    return finalCodes.map((code) =>
      (cfg.availableLanguages || []).find((l) => l.iso_code === code) || { iso_code: code }
    );
  }

  function defaultLocaleForCountry(countryIso) {
    const preferred = cfg.defaultLocaleByCountry?.[countryIso];
    const allowed = getLocalesForCountry(countryIso).map((l) => l.iso_code);
    return preferred && allowed.includes(preferred) ? preferred : allowed[0] || null;
  }

  function collectSellableCountryHandlesFromApi(apiData) {
    const set = new Set();
    for (const s of apiData?.suggestions || []) {
      const opts = s?.parts?.country?.options;
      if (opts && typeof opts === 'object') {
        Object.keys(opts).forEach((k) => set.add(k.toUpperCase()));
      }
      const handle = s?.parts?.country?.handle;
      if (typeof handle === 'string') set.add(handle.toUpperCase());
    }
    return set;
  }

  function getSellableCountrySet(apiData) {
    const set = collectSellableCountryHandlesFromApi(apiData);
    (cfg.availableCountries || []).forEach((c) => set.add(c.iso_code));
    return set;
  }

  function isDetectedInSellableMarkets(detectedIso, apiData) {
    if (!detectedIso) return false;
    return getSellableCountrySet(apiData).has(detectedIso);
  }

  function shouldShowWrongMarket(detectedIso, storefrontIso, apiData) {
    if (!detectedIso || detectedIso === storefrontIso) return false;
    return isDetectedInSellableMarkets(detectedIso, apiData);
  }

  function hasEnglishLocaleForCountry(countryIso) {
    return getLocalesForCountry(countryIso).some((l) => {
      const code = String(l.iso_code || '').toLowerCase();
      return code === 'en' || code.startsWith('en-');
    });
  }

  /** First-visit language popup: only when 2+ languages and none is English (single-lang or EN+local → no auto popup). */
  function shouldAutoShowLanguagePickerOnFirstVisit(countryIso) {
    const locales = getLocalesForCountry(countryIso);
    if (locales.length <= 1) return false;
    if (hasEnglishLocaleForCountry(countryIso)) return false;
    return true;
  }

  function getBrowsingContextSuggestionsUrl() {
    let root = '/';
    if (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    } else if (window.themeVariables?.routes?.rootUrl) {
      root = window.themeVariables.routes.rootUrl;
    }
    if (root !== '/' && !root.endsWith('/')) {
      root += '/';
    }
    const langEx = cfg.languageIso || (cfg.currentLocale || '').split('-')[0] || '';
    const params = new URLSearchParams();
    params.set('country[enabled]', 'true');
    params.set('country[exclude]', cfg.currentCountry);
    params.set('language[enabled]', 'true');
    if (langEx) params.set('language[exclude]', langEx);
    return `${root}browsing_context_suggestions.json?${params.toString()}`;
  }

  async function getBrowsingContextData() {
    const url = getBrowsingContextSuggestionsUrl();
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (res.ok) return await res.json();
    } catch (e) {
      /* ignore */
    }
    return null;
  }

  function parseDetectedCountry(apiData) {
    const h = apiData?.detected_values?.country?.handle;
    if (typeof h === 'string' && h.length) return h.toUpperCase();
    const c = cfg.detectedCountry;
    return typeof c === 'string' ? c.toUpperCase() : null;
  }

  function regionNameForIso(iso) {
    if (!iso) return '';
    try {
      return new Intl.DisplayNames(['en'], { type: 'region' }).of(iso);
    } catch (e) {
      return iso;
    }
  }

  function setBodyLock(on) {
    document.body.style.overflow = on ? 'hidden' : '';
    document.documentElement.style.scrollbarGutter = on ? 'stable' : '';
  }

  function applySuggestedMarketToPicker(suggestedCountryIso) {
    if (!suggestedCountryIso) return;
    const isoUp = suggestedCountryIso.toUpperCase();
    const countryBtn = [...picker.countryListOpts].find(
      (b) => (b.dataset.countryCode || '').toUpperCase() === isoUp
    );
    if (!countryBtn) return;

    const localeCode = defaultLocaleForCountry(countryBtn.dataset.countryCode);
    state.country = countryBtn.dataset.countryCode;
    if (localeCode) state.locale = localeCode;
    if (inputs.country) inputs.country.value = state.country;
    if (inputs.locale && localeCode) inputs.locale.value = localeCode;

    if (picker.countryLabel) picker.countryLabel.textContent = countryBtn.dataset.countryName;

    const cflag = countryBtn.querySelector('.loc-picker__option-flag');
    if (cflag && picker.countryFlag) picker.countryFlag.innerHTML = cflag.innerHTML;

    picker.countryListOpts.forEach((b) => {
      b.classList.toggle('is-active', b === countryBtn);
      b.setAttribute('aria-selected', b === countryBtn ? 'true' : 'false');
    });

    filterLanguages(state.country);

    if (localeCode) {
      const langBtn = [...picker.langListOpts].find((b) => b.dataset.localeCode === localeCode);
      if (langBtn) selectLanguage(langBtn);
    }
  }

  function openPicker(returnTo) {
    els.wrong.setAttribute('hidden', '');
    els.picker.removeAttribute('hidden');
    setBodyLock(true);
    picker.triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));
    moveFocusInto(els.picker, returnTo);
  }

  function closePicker(restore = true) {
    const wasOpen = !els.picker.hidden;
    els.picker.setAttribute('hidden', '');
    setBodyLock(false);
    closeAllDropdowns();
    picker.triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    if (wasOpen) restoreFocus(restore);
  }

  function openWrongMarket(detectedIso) {
    lastWrongMarketDetectedIso = detectedIso || null;
    const name = regionNameForIso(detectedIso);
    if (wrong.title) {
      wrong.title.textContent = String(cfg.strings.wrongTitle).replace(/\{country\}/g, name);
    }
    if (wrong.subtitle) {
      wrong.subtitle.textContent = cfg.strings.wrongSubtitle;
    }
    els.wrong.removeAttribute('hidden');
    setBodyLock(true);
    moveFocusInto(els.wrong);
  }

  function closeWrongMarket(restore = true) {
    const wasOpen = !els.wrong.hidden;
    els.wrong.setAttribute('hidden', '');
    setBodyLock(false);
    if (wasOpen) restoreFocus(restore);
  }

  function closeAllDropdowns() {
    picker.dropdowns.forEach((wrap) => {
      if (!wrap.classList.contains('is-open')) return;
      wrap.classList.remove('is-open');
      const t = wrap.querySelector('.loc-picker__trigger');
      const list = wrap.querySelector('.loc-picker__list');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (list) list.hidden = true;
    });
  }

  function setupDropdown(items, onSelect) {
    items.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        onSelect(btn);
        closeAllDropdowns();
      });
    });
  }

  function selectLanguage(btn) {
    state.locale = btn.dataset.localeCode;
    if (inputs.locale) inputs.locale.value = state.locale;

    if (picker.langLabel) picker.langLabel.textContent = btn.dataset.localeName;

    picker.langListOpts.forEach((b) => {
      b.classList.toggle('is-active', b === btn);
      b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
    });
  }

  function filterLanguages(countryIso) {
    const allowed = new Set(getLocalesForCountry(countryIso).map((l) => l.iso_code));

    picker.langListOpts.forEach((btn) => {
      const li = btn.closest('li');
      if (li) li.hidden = !allowed.has(btn.dataset.localeCode);
    });

    if (!allowed.has(state.locale)) {
      const fallback = defaultLocaleForCountry(countryIso);
      const next = [...picker.langListOpts].find((b) => b.dataset.localeCode === fallback);
      if (next) selectLanguage(next);
    }
  }

  picker.dropdowns.forEach((wrap) => {
    const trigger = wrap.querySelector('.loc-picker__trigger');
    const list = wrap.querySelector('.loc-picker__list');
    if (!trigger || !list) return;
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = wrap.classList.toggle('is-open');
      list.hidden = !open;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      picker.dropdowns.forEach((other) => {
        if (other !== wrap && other.classList.contains('is-open')) {
          other.classList.remove('is-open');
          const ot = other.querySelector('.loc-picker__trigger');
          const ol = other.querySelector('.loc-picker__list');
          if (ot) ot.setAttribute('aria-expanded', 'false');
          if (ol) ol.hidden = true;
        }
      });
    });
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.loc-picker__control')) return;
    closeAllDropdowns();
  });

  setupDropdown(picker.countryOpts, (btn) => {
    state.country = btn.dataset.countryCode;
    if (inputs.country) inputs.country.value = state.country;

    if (picker.countryLabel) picker.countryLabel.textContent = btn.dataset.countryName;

    const flag = btn.querySelector('.loc-picker__option-flag');
    if (flag && picker.countryFlag) picker.countryFlag.innerHTML = flag.innerHTML;

    picker.countryListOpts.forEach((b) => {
      b.classList.toggle('is-active', b === btn);
      b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
    });

    filterLanguages(state.country);
  });

  setupDropdown(picker.langOpts, selectLanguage);

  picker.closeCtrls.forEach((el) => {
    el.addEventListener('click', () => {
      closePicker();
      markAsSeen();
    });
  });

  wrong.closeTargets.forEach((el) => {
    el.addEventListener('click', () => {
      closeWrongMarket();
    });
  });

  wrong.stay?.addEventListener('click', () => {
    setMarketChoice(cfg.currentCountry);
    closeWrongMarket();
    markAsSeen();
  });

  wrong.openPickerBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const suggested = lastWrongMarketDetectedIso;
      const returnTo = returnFocusTarget;
      clearMarketChoice();
      closeWrongMarket(false);
      applySuggestedMarketToPicker(suggested);
      openPicker(returnTo);
    });
  });

  picker.triggers.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (els.picker.hidden) {
        openPicker(btn);
      } else {
        closePicker();
      }
    });
  });

  window.addEventListener('keydown', (event) => {
    const modal = openModalElement();
    if (!modal) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      const openDropdown = modal === els.picker ? Array.from(picker.dropdowns).find((wrap) => wrap.classList.contains('is-open')) : null;
      if (openDropdown) {
        closeAllDropdowns();
        const dropdownTrigger = openDropdown.querySelector('.loc-picker__trigger');
        if (dropdownTrigger) dropdownTrigger.focus({ preventScroll: true });
      } else if (modal === els.picker) {
        closePicker();
        markAsSeen();
      } else {
        closeWrongMarket();
      }
      return;
    }
    if (event.key !== 'Tab') return;
    const items = focusablesIn(modal);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;
    let next = null;
    if (!modal.contains(active)) {
      next = event.shiftKey ? last : first;
    } else if (event.shiftKey && active === first) {
      next = last;
    } else if (!event.shiftKey && active === last) {
      next = first;
    }
    if (!next) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    next.focus({ preventScroll: true });
  }, true);

  if (inputs.form) {
    const saveBtn = inputs.form?.querySelector('[type="submit"]');

    if (saveBtn) {
      saveBtn.addEventListener('click', () => {
        setMarketChoice(state.country);
        markAsSeen();
      });
    }
  }

  function openLocalePickerIfNeeded() {
    if (sessionStorage.getItem(keys.session)) return;
    if (shouldAutoShowLanguagePickerOnFirstVisit(cfg.currentCountry)) {
      openPicker();
    }
  }

  async function runLocaleFlow() {
    const stored = getMarketChoice();
  
    if (stored) return;
  
    if (sessionStorage.getItem(keys.session)) return;
  
    const storefrontIso = cfg.currentCountry;
    const apiData = await getBrowsingContextData();
    const detectedIso = parseDetectedCountry(apiData);
  
    const status = getMarketStatus(detectedIso, storefrontIso, apiData);
  
    if (status === 'mismatch') {
      openWrongMarket(detectedIso);
      return;
    }
  
    if (status === 'not-sellable') {
      openPicker();
      return;
    }
  
    if (status === 'correct') {
      if (shouldAutoShowLanguagePickerOnFirstVisit(storefrontIso)) {
        openLocalePickerIfNeeded();
      } else {
        setMarketChoice(storefrontIso);
      }
    }
  }

  filterLanguages(state.country);

  runLocaleFlow().catch(() => { });

  if (picker.menuDrawer) {
    picker.menuDrawer.addEventListener('openable-element:close', () => {
      closePicker(false);
      closeWrongMarket(false);
      setBodyLock(false);
      picker.triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    });
  }
})();
